<template>
  <div
    v-click-outside="closeOptions"
    class="aside-options"
    @click="open = !open"
  >
    <Icon class="aside-options__dots" icon="option-circles" />
    <slide-up-down
      :active="open"
      :duration="200"
      tag="ul"
      class="aside-options__field"
    >
      <slot name="items" />
      <li
        v-if="optionDeleteText"
        class="aside-options__item"
        @click="optionDelete"
      >
        <Icon class="aside-options__icon" icon="delete" />
        <p class="aside-options__text">
          {{ optionDeleteText }}
        </p>
      </li>
    </slide-up-down>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';

export default {
  directives: { clickOutside: vClickOutside.directive },
  components: { SlideUpDown },
  props: ['isOpen', 'optionDeleteText', 'optionDeleteConfirmText'],
  data: () => ({
    open: false
  }),
  watch: {
    isOpen() {
      this.open = false;
    }
  },
  methods: {
    optionDelete() {
      if (!this.optionDeleteConfirmText) {
        this.$emit('optionDelete');
      } else {
        this.$emit('deleteConfirm');
      }
    },
    closeAside() {
      this.$emit('closeAside');
    },
    closeOptions() {
      this.open = false;
    }
  }
};
</script>
